


import { TextField } from "@mui/material";
import { Search } from "lucide-react";

interface SearchInputProps {
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  width?: string | number;
}

function SearchInput({
  value,
  onChange,
  placeholder = "Search",
  className = "",
  width = 220,
}: SearchInputProps) {
  return (
    <div
      className={`inline-block align-top relative ${className}`}
      style={{ width }}
    >
      <TextField
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        variant="outlined"
        size="small"
        fullWidth
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "7px",
            backgroundColor: "#fff",
            height: "36px",
            "& fieldset": {
              borderColor: "#e2e6eb",
            },
            "&:hover fieldset": {
              borderColor: "#c5ccd6",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#4a90d9",
              borderWidth: "1.5px",
            },
          },
          "& .MuiInputBase-input": {
            padding: "0 34px 0 10px",
            fontSize: "13px",
            height: "36px",
            boxSizing: "border-box",
            color: "#1a2233",
            "&::placeholder": {
              color: "#9aa0ab",
              opacity: 1,
            },
          },
        }}
      />
      <Search
        size={15}
        className="absolute top-[50%] -translate-y-1/2 right-[10px] pointer-events-none"
        style={{ color: "#b0b8c5" }}
      />
    </div>
  );
}

export default SearchInput;